import { render } from "./DownloadBtn.vue?vue&type=template&id=74535890&scoped=true"
import script from "./DownloadBtn.vue?vue&type=script&lang=js"
export * from "./DownloadBtn.vue?vue&type=script&lang=js"

import "./DownloadBtn.vue?vue&type=style&index=0&id=74535890&lang=scss&scoped=true"

import exportComponent from "/builds/web-primary/web-ask-review/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74535890"]])

export default __exports__